import { useCuentasBancariasAll } from "api/CuentaBancaria.hook"
import { FORMA_PAGO } from "api/Types/FormaPago"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import Button from "common/components/Button/Button"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { globalSelector } from "routes/globalSlice"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setShowFormaPago } from "../redux/slices/newDocumentoSettingsSlice"
import {
  newDocumentoSelectorDoc,
  updateFormaPago,
} from "../redux/slices/newDocumentoSlice"

const FormaPago = ({
  setIsEditFormaPago,
  values,
  handleSubmit,
  onHide,
  isValid,
  setFieldValue,
  isEditFormaPago,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const prevValue = {
    formaPago: values.formaPago,
    formaPagoIbanInput: values.formaPagoIbanInput,
    formaPagoIban: values.formaPagoIban,
  }
  // TODO: GLOBALSELECTOR A RQ
  const { formasPago } = useSelector(globalSelector)
  const mappedFormasPago = useMemo(() => {
    return formasPago.map((f: $TSMigrationFixMe) => ({
      ...f,
      value: f.id,
    }))
  }, [formasPago])
  const { cuentaBancariaAll } = useCuentasBancariasAll({})
  // TODO: newDocumentoSelector A RQ
  const { librado } = useSelector(newDocumentoSelector)
  const { librador } = useSelector(newDocumentoSelectorDoc)

  const {
    activeCompany: { nif },
  } = useUsuarioEmpresaActiva()

  const mappedlistBankAccounts = useMemo(() => {
    // @ts-expect-error TS(2698): Spread types may only be created from object types...
    return cuentaBancariaAll?.items.map((f) => ({ ...f, value: f.id }))
  }, [cuentaBancariaAll?.items])
  const dropdownIbanList =
    values.formaPago === FORMA_PAGO.TRANSFERENCIA
      ? mappedlistBankAccounts?.filter(
          (account) => account.necesitaValidacion === false
        )
      : librado?.cuentasBancarias

  const handleCuentaBancaria = async (e: $TSMigrationFixMe) => {
    const matchAccount =
      values.formaPago === FORMA_PAGO.TRANSFERENCIA
        ? mappedlistBankAccounts?.find(
            (cuenta) =>
              cuenta?.cuentaContableEmpresaId === e.target.value ||
              cuenta?.id === e.target.value
          )?.iban
        : librado?.cuentasBancarias?.find(
            (cuenta: $TSMigrationFixMe) => cuenta?.id === e.target.value
          )?.iban
    setFieldValue("formaPagoIbanInput", e.target.value)
    setFieldValue("formaPagoIban", matchAccount)
  }

  const resetFormPagoIban = () => {
    setFieldValue("formaPagoIbanInput", "")
    setFieldValue("formaPagoIban", "")
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='tw-mb-2'>
        <div className='tw-mb-4 tw-flex tw-flex-col'>
          <label htmlFor='formaPago'>
            {t("crear.facturaRec.modal.paymentFormLabel")}
          </label>

          <Dropdown
            options={mappedFormasPago}
            value={values.formaPago}
            onChange={(e) => {
              setFieldValue("formaPago", e.target.value)
            }}
            inputId='formaPago'
            name='formaPago'
            optionLabel='description'
            // @ts-expect-error TS(2769): No overload matches this call.
            placeholder={t("crear.facturaRec.modal.placeholderPaymentForm")}
            panelClassName='!tw-z-50'
          />
        </div>
        {(librador?.nif === nif || librador?.cif === nif) &&
          (values.formaPago === FORMA_PAGO.TRANSFERENCIA ||
            values.formaPago === FORMA_PAGO.PAGO_DOMICILIADO) && (
            <div className='tw-mb-4'>
              <label htmlFor='formaPagoIbanInput'>
                {t("crear.facturaRec.modal.paymentFormBankAccountLabel")}
              </label>

              <Dropdown
                options={[
                  {
                    iban: t(
                      "crear.facturaRec.modal.dropdownPaymentBankNotSelected"
                    ),
                    id: null,
                  },
                  ...(dropdownIbanList || []),
                ]}
                inputId='formaPagoIbanInput'
                value={values.formaPagoIbanInput}
                onChange={handleCuentaBancaria}
                name='formaPagoIbanInput'
                optionLabel='iban'
                optionValue='id'
                className='!tw-w-full'
                // @ts-expect-error TS(2769): No overload matches this call.
                placeholder={t(
                  "crear.facturaRec.modal.placeHolderPaymentFormBankAccount"
                )}
                editable={false}
              />
            </div>
          )}
      </div>

      <div className='tw-mt-6'>
        <div className='tw-flex tw-flex-row tw-justify-end tw-items-center'>
          <a
            role='button'
            href='#'
            className='tw-mr-4 tw-text-primary tw-cursor-pointer tw-no-underline hover:tw-no-underline'
            onClick={() => {
              onHide()
              isEditFormaPago && setIsEditFormaPago(false)
            }}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>

          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
            onClick={() => {
              if (
                isEditFormaPago &&
                ((prevValue.formaPago === FORMA_PAGO.TRANSFERENCIA &&
                  values.formaPago === FORMA_PAGO.PAGO_DOMICILIADO) ||
                  (prevValue.formaPago === FORMA_PAGO.PAGO_DOMICILIADO &&
                    values.formaPago === FORMA_PAGO.TRANSFERENCIA)) &&
                prevValue.formaPagoIban === values.formaPagoIban
              ) {
                resetFormPagoIban()
              } else if (
                isEditFormaPago &&
                values.formaPago !== FORMA_PAGO.PAGO_DOMICILIADO &&
                values.formaPago !== FORMA_PAGO.TRANSFERENCIA
              ) {
                resetFormPagoIban()
              }
            }}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  formaPago: Yup.number().required(),
  formaPagoIban: Yup.string().nullable(),
  formaPagoIbanInput: Yup.string().nullable(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  // @ts-expect-error TS(2339): Property 'formaPago' does not exist on type '{}'.
  mapPropsToValues: ({ formaPago, formaPagoIban, formaPagoCuentaId }) => ({
    formaPago,
    formaPagoIban,
    formaPagoIbanInput: formaPagoCuentaId,
  }),
  validateOnMount: true,
  handleSubmit: (
    { formaPago, formaPagoIban, formaPagoIbanInput },
    { props }
  ) => {
    // @ts-expect-error TS(2339): Property 'formasPago' does not exist on type 'obje...
    const formaPagoDescription = props.formasPago?.find(
      (forma: $TSMigrationFixMe) => formaPago === forma.id
    )?.description
    // @ts-expect-error TS(2339): Property 'updateFormaPago' does not exist on type ...
    props.updateFormaPago({
      formaPago,
      formaPagoDescription,
      formaPagoIban,
      formaPagoCuentaId: formaPagoIbanInput,
    })
    // @ts-expect-error TS(2339): Property 'setShowFormaPago' does not exist on type...
    props.setShowFormaPago(true)
    // @ts-expect-error TS(2339): Property 'isEditFormaPago' does not exist on type ...
    props.isEditFormaPago && props.setIsEditFormaPago(false)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(FormaPago)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setShowFormaPago: (show: $TSMigrationFixMe) =>
    dispatch(setShowFormaPago(show)),
  updateFormaPago: (formaPago: $TSMigrationFixMe) =>
    dispatch(updateFormaPago(formaPago)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  formaPago: newDocumentoSelector(state).formaPago,
  formaPagoIban: newDocumentoSelector(state).formaPagoIban,
  formaPagoCuentaId: newDocumentoSelector(state).formaPagoCuentaId,
  formasPago: globalSelector(state).formasPago,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
